var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chats-list-container"},[(!_vm.hideAdminCalls)?_c('ChatsList'):_vm._e(),_c('ChatsContainer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }